import React from "react";
import {
    Grid,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(() => ({
    marginBetween: {
        marginTop: "3em",
        ["@media (min-width: 780px)"]: {
            marginTop: "5em",
        },
    },
}));

type RankingsProps = {
    allTimeBestRank: string;
    rank: string;
    thisWeekBestRank: string;
}

export default function Rankings({ allTimeBestRank, rank, thisWeekBestRank }: RankingsProps): JSX.Element {
    const { t } = useTranslation();

    const classes = useStyles();

    return (
        <Grid container direction="column" justify="space-evenly">
            <Grid container direction="row" justify="space-between">
                <Typography variant="h4">
                    {t("rankings.current-position")}
                </Typography>
                <Typography variant="h4">
                    {rank}
                </Typography>
            </Grid>
            <Grid container direction="row" justify="space-between" classes={{ root: classes.marginBetween }}>
                <Typography variant="h4">
                    {t("rankings.top-week")}
                </Typography>
                <Typography variant="h4">
                    {thisWeekBestRank}
                </Typography>
            </Grid>
            <Grid container direction="row" justify="space-between" classes={{ root: classes.marginBetween }}>
                <Typography variant="h4">
                    {t("rankings.top-all-time")}
                </Typography>
                <Typography variant="h4">
                    {allTimeBestRank}
                </Typography>
            </Grid>
        </Grid>
    );
}
